<motn-drawer-gap-from-top
  (clickedOutside$)="closed$.emit($event)"
>
  <h2>
    <div>

      <div
        class="violet"
      >
        <i class="fa-light fa-share"></i>
        <motn-pill
          [squareLetter]="pillLetter"
        >{{ object.id }}</motn-pill>
      </div>


      <div class="name">
        {{object.name}}
      </div>
    </div>

    <button
      class="small white violet"
      (click)="share()"
    >
      Add User
    </button>
  </h2>

  @if (!userIsOwner) {
    <motn-banner
      [bkgdColor]="'blue'"
    >
      This {{object.type}} is owned by
      <motn-user-link
        [userId]="object.owner"
        [showUsername]="true"
      ></motn-user-link>
    </motn-banner>
  }

  @if (rolePickerGrantees) {
    <motn-sort-table
      [table$]="table$"
    ></motn-sort-table>
  }
</motn-drawer-gap-from-top>
